import {
    CREATE_STITCHING_INWARD_MASTER_REQUEST_DK,
    CREATE_STITCHING_INWARD_MASTER_SUCCESS_DK,
    CREATE_STITCHING_INWARD_MASTER_FAILURE_DK,
    DELETE_STITCHING_INWARD_MASTER_REQUEST_DK,
    DELETE_STITCHING_INWARD_MASTER_SUCCESS_DK,
    DELETE_STITCHING_INWARD_MASTER_FAILURE_DK,
    FETCH_SINGLE_STITCHING_INWARD_MASTER_REQUEST_DK,
    FETCH_SINGLE_STITCHING_INWARD_MASTER_SUCCESS_DK,
    FETCH_SINGLE_STITCHING_INWARD_MASTER_FAILURE_DK,
    FETCH_STITCHING_INWARD_MASTER_REQUEST_DK,
    FETCH_STITCHING_INWARD_MASTER_SUCCESS_DK,
    FETCH_STITCHING_INWARD_MASTER_FAILURE_DK,
    UPDATE_STITCHING_INWARD_MASTER_REQUEST_DK,
    UPDATE_STITCHING_INWARD_MASTER_SUCCESS_DK,
    UPDATE_STITCHING_INWARD_MASTER_FAILURE_DK,
    RESET_STITCHING_INWARD_MASTER_INFO_DK,
    CREATE_STITCHING_INWARD_MASTER_FORM_DK,
    UPDATE_STITCHING_INWARD_MASTER_FORM_DK,
    NAVIGATE_STITCHING_INWARD_DETAILS_DK,
    NAVIGATE_STITCHING_INWARD_MASTER_DK,
    FETCH_PENDING_STITCHING_PO_IN_INWARD_REQUEST_DK,
    FETCH_PENDING_STITCHING_PO_IN_INWARD_SUCCESS_DK,
    FETCH_PENDING_STITCHING_PO_IN_INWARD_FAILURE_DK,
    SET_ACTIVE_KEY_STITCHING_INWARD_DK,
    RESET_FORM_DATA_WITHOUT_STITCHING_INWARD_ID_DK,
    FETCH_STITCHING_INWARD_MASTER_EDIT_QUANTITY_REQUEST_DK,
    FETCH_STITCHING_INWARD_MASTER_EDIT_QUANTITY_SUCCESS_DK,
    FETCH_STITCHING_INWARD_MASTER_EDIT_QUANTITY_FAILURE_DK,
    RESET_EDIT_QUANTITY_GRID_DATA_WITHOUT_STITCHING_INWARD_ID_DK,
    CREATE_STITCHING_INWARD_EDIT_QTY_MASTER_REQUEST_DK,
    CREATE_STITCHING_INWARD_EDIT_QTY_MASTER_SUCCESS_DK,
    CREATE_STITCHING_INWARD_EDIT_QTY_MASTER_FAILURE_DK,
    SET_PENDING_GRID_NAME_STITCHING_INWARD_DK,
    SET_UNIT_NAME_STITCHING_INWARD_DK,
    FETCH_COMPLETE_STITCHING_DC_IN_INWARD_REQUEST_DK,
    FETCH_COMPLETE_STITCHING_DC_IN_INWARD_SUCCESS_DK,
    FETCH_COMPLETE_STITCHING_DC_IN_INWARD_FAILURE_DK,
    FETCH_SINGLE_DATA_FOR_REPORT_REQUEST_DK,
    FETCH_SINGLE_DATA_FOR_REPORT_SUCCESS_DK,
    FETCH_SINGLE_DATA_FOR_REPORT_FAILURE_DK,
} from './stitchingInwardHeader.actionsType';

export const STITCHING_INWARD_DK_MASTER = 'stitchingInwardDKHeader';

let initialState = {
    loading: false,
    stitchingInwardHeader: [],
    stitchingInwardHeaderEditQuantity: [],
    pendingStitchingDc: [],
    completeStitchDC:[],
    reportSingleStitchProgramInwardList:[],
    activeKey: 1,
    stitchingInwardId: '',
    detailsId: [],
    styleData: {},
    stitchingInwardHeaderForm: {
        fldSupplierInvoiceNo: null,
        fldSupplierInvoiceDate: null,
        fldSupplierInvoiceValue: null,
        fldSupplierDCNo: null,
        fldSupplierDCDate: null,
        fldSupplierDCValue: null,
        fldGrossValue: 0,
        fldDiscountValue: 0,
        fldDiscountPercentage: 0,
        fldIGSTValue: 0,
        fldSGSTValue: 0,
        fldCGSTValue: 0,
        fldTaxableValue: 0,
        fldGSTValue: 0,
        fldSGSTPercentage: 0,
        fldCGSTPercentage: 0,
        fldIGSTPercentage: 0
    },
    selectedState: {},
    typeOfPoList: [],
    renderGridBtn: 'pendingGrid',
    unitId: '',
    sourceList: [],
    departmentList: [],
    deliveryAt: [],
    errorMessage: '',
    singleStitchingInwardData: {},
    isStitchingInwardDetails: false
};

export let stitchingInwardDKHeaderReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_STITCHING_INWARD_MASTER_REQUEST_DK:
        case FETCH_STITCHING_INWARD_MASTER_EDIT_QUANTITY_REQUEST_DK:
        case FETCH_PENDING_STITCHING_PO_IN_INWARD_REQUEST_DK:
        case CREATE_STITCHING_INWARD_MASTER_REQUEST_DK:
        case CREATE_STITCHING_INWARD_EDIT_QTY_MASTER_REQUEST_DK:
        case UPDATE_STITCHING_INWARD_MASTER_REQUEST_DK:
        case FETCH_SINGLE_STITCHING_INWARD_MASTER_REQUEST_DK:
        case DELETE_STITCHING_INWARD_MASTER_REQUEST_DK:
        case FETCH_COMPLETE_STITCHING_DC_IN_INWARD_REQUEST_DK:
        case FETCH_SINGLE_DATA_FOR_REPORT_REQUEST_DK:
            return {
                ...state,
                loading: true
            };
        case FETCH_STITCHING_INWARD_MASTER_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                stitchingInwardHeader: updatePayload
            };
        case FETCH_STITCHING_INWARD_MASTER_EDIT_QUANTITY_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                stitchingInwardHeaderEditQuantity: updatePayload?.CUD,
                activeKey: 2
            };
        case FETCH_PENDING_STITCHING_PO_IN_INWARD_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                pendingStitchingDc: updatePayload
            };
        case CREATE_STITCHING_INWARD_MASTER_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                stitchingInwardHeaderForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierDCValue: null,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldDiscountPercentage: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0
                },
                stitchingInwardId: payload[0]?.fldID,
                detailsId: payload,
                activeKey: 2
            };
        case CREATE_STITCHING_INWARD_EDIT_QTY_MASTER_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                stitchingInwardHeaderForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierDCValue: null,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldDiscountPercentage: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0
                },
                activeKey: 1,
                detailsId: []
            };
            case FETCH_COMPLETE_STITCHING_DC_IN_INWARD_SUCCESS_DK:
                return {
                    ...state,
                    loading: false,
                    completeStitchDC: updatePayload
                };
                case FETCH_SINGLE_DATA_FOR_REPORT_SUCCESS_DK:
                    return {
                        ...state,
                        loading: false,
                        reportSingleStitchProgramInwardList: updatePayload
                    };
        case UPDATE_STITCHING_INWARD_MASTER_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                stitchingInwardHeaderForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierDCValue: null,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldDiscountPercentage: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0
                }
            };
        case FETCH_SINGLE_STITCHING_INWARD_MASTER_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                stitchingInwardHeaderForm: {
                    ...payload,
                    fldSupplierInvoiceDate: payload?.fldSupplierInvoiceDate && payload?.fldSupplierInvoiceDate.split('T')[0],
                    fldSupplierDCDate: payload?.fldSupplierDCDate && payload?.fldSupplierDCDate.split('T')[0]
                }
            };
        case DELETE_STITCHING_INWARD_MASTER_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                stitchingInwardHeaderForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierDCValue: null,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldDiscountPercentage: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0
                }
            };
        case RESET_STITCHING_INWARD_MASTER_INFO_DK:
            return {
                ...state,
                stitchingInwardHeaderForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierDCValue: null,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldDiscountPercentage: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0
                },
                // stitchingInwardId: '',
                styleData: {},
                activeKey: 1
            };
        case CREATE_STITCHING_INWARD_MASTER_FORM_DK:
        case UPDATE_STITCHING_INWARD_MASTER_FORM_DK:
            return {
                ...state,
                loading: false,
                stitchingInwardHeaderForm: {
                    ...state.stitchingInwardHeaderForm,
                    [payload.key]: payload.value
                }
            };
        case SET_ACTIVE_KEY_STITCHING_INWARD_DK:
            return {
                ...state,
                loading: false,
                activeKey: 1
            };
        case RESET_EDIT_QUANTITY_GRID_DATA_WITHOUT_STITCHING_INWARD_ID_DK:
            return {
                ...state,
                loading: false,
                stitchingInwardHeaderEditQuantity: [],
                detailsId: []
            };
        case FETCH_STITCHING_INWARD_MASTER_FAILURE_DK:
        case FETCH_STITCHING_INWARD_MASTER_EDIT_QUANTITY_FAILURE_DK:
        case FETCH_PENDING_STITCHING_PO_IN_INWARD_FAILURE_DK:
        case CREATE_STITCHING_INWARD_MASTER_FAILURE_DK:
        case CREATE_STITCHING_INWARD_EDIT_QTY_MASTER_FAILURE_DK:
        case UPDATE_STITCHING_INWARD_MASTER_FAILURE_DK:
        case FETCH_SINGLE_STITCHING_INWARD_MASTER_FAILURE_DK:
        case DELETE_STITCHING_INWARD_MASTER_FAILURE_DK:
        case FETCH_COMPLETE_STITCHING_DC_IN_INWARD_FAILURE_DK:
        case FETCH_SINGLE_DATA_FOR_REPORT_FAILURE_DK:
            return {
                ...state,
                loading: false
            };
        case RESET_FORM_DATA_WITHOUT_STITCHING_INWARD_ID_DK:
            return {
                ...state,
                stitchingInwardHeaderForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierDCValue: null,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldDiscountPercentage: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0
                },
                selectedTeam: {}
            };
            case SET_PENDING_GRID_NAME_STITCHING_INWARD_DK:
                return {
                    ...state,
                    renderGridBtn: payload
                };
            case SET_UNIT_NAME_STITCHING_INWARD_DK:
                return {
                    ...state,
                    unitId: payload
                };
        case NAVIGATE_STITCHING_INWARD_DETAILS_DK:
            return {
                ...state,
                isStitchingInwardDetails: true,
                singleStitchingInwardData: updatePayload.singleStitchingInwardData
            };
        case NAVIGATE_STITCHING_INWARD_MASTER_DK:
            return {
                ...state,
                isStitchingInwardDetails: false
            };
        default:
            return state;
    }
};
